(function () {
    'use strict';

    /**
     * Venue map section - owns its maps and the selected map tab.
     * Used as an attribute on the server rendered <section> (Views/Events/_VenueMap.cshtml).
     * No template and a child scope, so the Razor markup inside binds to "venueMapSection"
     * and still sees the page "vm" (getStyle, showLoading).
     */
    angular
        .module('EventListApp')
        .directive('wsSectionVenueMap', sectionVenueMap);

    function sectionVenueMap() {
        return {
            restrict: 'A',
            scope: true,
            controller: SectionVenueMapCtrl,
            controllerAs: 'venueMapSection'
        };
    }

    SectionVenueMapCtrl.$inject = ['$element', 'ApiFactory', 'SectionRegistry'];

    function SectionVenueMapCtrl($element, ApiFactory, SectionRegistry) {
        const vm = this;
        let activeMap = 0;

        vm.$onInit = function () {
            SectionRegistry.register($element[0].id, load);
        };

        vm.isActiveMap = function (idx) {
            return activeMap == idx;
        };

        vm.setActiveMap = function (idx) {
            activeMap = idx;
        };

        /**
         * Load the venue maps of the event
         * @param {number} eventId
         * @param {number} lang
         * @returns {Promise}
         */
        function load(eventId, lang) {
            return ApiFactory.GetVenueMaps(eventId, lang).then(function (response) {
                vm.maps = response.data;
            });
        }
    }
})();
